import * as React from 'react';

interface IInfrastructureContextType {
  infrastructureButtonRef: React.RefObject<HTMLButtonElement>;
}

const InfrastructureContext = React.createContext<IInfrastructureContextType | null>(null);

interface IInfrastructureContextProviderProps {
  children: React.ReactNode;
}

export const InfrastructureContextProvider = ({ children }: IInfrastructureContextProviderProps) => {
  const infrastructureButtonRef = React.useRef<HTMLButtonElement>(null);

  const contextValue = React.useMemo(() => {
    return { infrastructureButtonRef };
  }, []);

  return <InfrastructureContext.Provider value={contextValue}>{children}</InfrastructureContext.Provider>;
};

export const useInfrastructureContext = (): IInfrastructureContextType => {
  const context = React.useContext(InfrastructureContext);

  if (!context) {
    throw new Error('useInfrastructureContext must be used within a InfrastructureProvider');
  }

  return context;
};
